import * as uuid from 'uuid';

export function getUuidV4(): string {
    return uuid.v4();
}
